import { render, staticRenderFns } from "./ImportShipmentNoForm.vue?vue&type=template&id=47b64b82&lang=pug"
import script from "./ImportShipmentNoForm.vue?vue&type=script&lang=js"
export * from "./ImportShipmentNoForm.vue?vue&type=script&lang=js"
import style0 from "./ImportShipmentNoForm.vue?vue&type=style&index=0&id=47b64b82&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports